import type { useOpenNotification } from 'utils/antd/notification-toasts';

import type { CreditorType } from 'api';

import { TRANSLATIONS } from './constants';

export const VALID_CREDITOR_TYPES: Array<CreditorType> = [
  'organization',
  'private'
];

// Utility for showing success notification
export const showSuccessNotification = (
  openNotification: ReturnType<typeof useOpenNotification>,
  fullName: string
) => {
  openNotification({
    kind: 'success',
    message: TRANSLATIONS.DESTROY_RECEIVER_SUCCESS(fullName)
  });
};

// Utility for showing error notification
export const showErrorNotification = (
  openNotification: ReturnType<typeof useOpenNotification>,
  errorMsg: string
) => {
  openNotification({
    kind: 'error',
    message: `${TRANSLATIONS.DESTROY_RECEIVER_ERROR} - ${errorMsg}`
  });
};
